import { render, staticRenderFns } from "./usersIcon.vue?vue&type=template&id=345f4c15&"
import script from "./usersIcon.vue?vue&type=script&lang=js&"
export * from "./usersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports